<ng-template #template let-row="row">
  <div *ngIf="row.hasProductSupplements; else noProductSupplements" class="column-product-supplements flex--row">
    <!-- Add/modify button -->
    <div class="column-product-supplements__button-wrapper">
      <button mat-button data-test="c" class="button--text" (click)="openProductSupplement(row)" *ngIf="editable && row.hasProductSupplements">
        <mat-icon> {{ row.productSupplements?.length ? 'edit' : 'add' }}</mat-icon>
        <span *ngIf="!row.productSupplements?.length">
          {{ 'cart.supplement.add-product-supplement' | translate }}
        </span>
      </button>
    </div>

    <!-- Product additives -->
    <div *ngIf="row?.productSupplements.length" class="supplement-information-wrapper flex--column">
      <div *ngFor="let supplement of row.productSupplements" class="supplement-information flex--row">
        <div>{{ supplement?.description }}</div>
        <div class="supplement-information__quantity flex__child text--gray text--right">
          {{ (supplement?.quantity / 100) * row?.quantity | agrNumber }}
          {{ 'unit.' + row.orderingInformation.orderUnit | translate }}
          ({{ supplement?.quantity | agrNumber }}%)
        </div>
      </div>
    </div>
  </div>

  <ng-template #noProductSupplements>-</ng-template>
</ng-template>
